<template>
  <div class="system-menu-container">
    <!-- TAB 切换栏 -->
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="发版管理" name="release" />
      <el-tab-pane label="FAQ管理" name="faq" />
	  <el-tab-pane label="弹窗公告管理" name="notice" />
	  <el-tab-pane label="用户反馈管理" name="feedback" />
    </el-tabs>

    <!-- 动态渲染子组件 -->
    <div class="tab-content">
      <!-- 1. 菜单管理 -->
      <Release v-if="activeTab === 'release'" ref="releaseTable" />
	  <FaqTable v-if="activeTab === 'faq'" ref="faqTable" />
	  <NoticeTable  v-if="activeTab === 'notice'" ref="notice" />
	  <UserFeedback  v-if="activeTab === 'feedback'" ref="userFeedback" />
    </div>
  </div>
</template>

<script>
// 导入所有子组件
import Release from './components/release.vue'
import FaqTable from './components/faqtable.vue'
import NoticeTable from './components/noticeTable.vue'
import UserFeedback from './components/userFeedback.vue'


export default {
  name: 'Information',
  components: {
		Release,
		FaqTable,
		NoticeTable,
		UserFeedback
  },
  data() {
    return {
      activeTab: 'release' // 默认显示菜单管理
    }
  },
  methods: {
    // TAB 切换事件
    handleTabClick(tab) {
      this.activeTab = tab.name
    }
  }
}
</script>

<style scoped>
.system-menu-container {
  padding: 20px;
}
.tab-content {
  margin-top: 20px;
}
</style>